import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Text from 'components/common/Text/Text'

const LoginHeaderTitle = ({ name }) =>
  <Title data-at-login-header-title headline size={ 20 }>{ name }</Title>

LoginHeaderTitle.propTypes = {
  name: PropTypes.string
}

LoginHeaderTitle.type = 'LoginHederTitle'

export default LoginHeaderTitle

const Title = styled(Text)`
  ${Mixin.mobileOnly()}
`
